import BaseComponent from '@/components/base';

export default class ProductVideo extends BaseComponent {
  get videoSrc() {
    return this.getAttribute('video-src') || '';
  }

  get videoPreviewImg() {
    return this.getAttribute('video-preview-img') || '';
  }

  render() {
    return `
      <video
        playsinline="playsinline"
        autoplay="autoplay"
        loop="loop"
        muted="muted"
        preload="metadata"
        poster="${this.videoPreviewImg}"
        style="border-radius:5px; width: 100%">
      >
        <source
          src="${this.videoSrc}"
          type="video/mp4"
        >
        <img src="${this.videoPreviewImg}"/>
      </video>`;
  }
}
